import { render, staticRenderFns } from "./SelectOrganization.vue?vue&type=template&id=0d473bf7"
import script from "./SelectOrganization.vue?vue&type=script&lang=js"
export * from "./SelectOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports